import { Box, Button } from '@mui/material';
import { useContext, useState } from 'react';
import Joyride from 'react-joyride';
import { ToolContext } from '../../../../../../core/context/ToolContext';
import { rqx } from '../../../../../../core/request/API';
import { env } from '../../../../../../core/Env';

export const CustomComponent = ({ step, index, totalSteps, primaryProps, closeProps, tooltipProps }) => {
	return (
		<Box {...tooltipProps} width="340px" p={2} bgcolor="#fff" borderRadius="8px">
			<Box fontSize="14px" fontWeight="600">{step.title}</Box>
			<Box fontSize="12px" py="4px">{step.content}</Box>

			<Box width="100%" display="flex" justifyContent="flex-end"  gap="4px">
				{[3, 4].includes(index) &&
					<Button {...closeProps} variant="text" sx={{ fontSize: '12px', p: '4px 16px' }}>
						Skip
					</Button>
				}
				<Button {...primaryProps} variant="contained" disableElevation sx={{fontSize: '12px', p: '4px 16px'}}>
					{index === 5 ? "Got it!" : "Next"}
				</Button>
			</Box>
		</Box>
	);
};

const steps = [
		{
			target: '.first-step',
			title: 'Publication',
			content: 'You will find publication',
			placement: 'top',
			disableBeacon: true,
			disableScrollParentFix: true,
			disableScrolling: true,
		},
		{
			target: '.second-step',
			title: 'Save',
			content: 'You will find your save item',
			placement: 'top',
			disableBeacon: true,
		},
		{
			target: '.third-step',
			title: 'Profile',
			content: 'You will find profile & more',
			placement: 'top',
			disableBeacon: true,
		},
		{
			target: '.fouth-step',
			title: 'Chat Personal',
			content: 'Connect with your family and friends anywhere.',
			placement: 'top',
			disableBeacon: true,
		},
		{
			target: '.fifth-step', // the CSS selector for the notification element
			title: 'Notifications',
			content: 'Here you can view all your recent notifications and updates.',
			placement: 'bottom', 
			disableBeacon: true, 
			disableScrollParentFix: true,
			disableScrolling: true, 
		},
		{
			target: '.six-step',
			title: 'My tools',
			content: 'Explore and grow 10x with your personal tools.',
			placement: 'top',
			disableBeacon: true,
		},
	];

export const General = () => {
	const { tool_state, personalization_state } = useContext(ToolContext);
	const { __SESSION } = tool_state;
    const { walkthrough } = personalization_state

	const [stepIndex, setStepIndex] = useState(0);

	const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8);
    const tool_id =  process.env.REACT_APP_TID_PSL;

	const handleJoyrideCallback = async (data) => {
		const { status, action, index, type } = data;

		let body = {
			user_id: user_id,
			tool_id: tool_id,
			feature_name: 'onboarding',
			personalization:[{sf_name: 'onboading', status: 1}, {sf_name: 'general' , status: 1}]
		}

		if (type === 'step:after' && action === 'next') {
            setStepIndex(index + 1);
        }

		if (status === "finished") {
			const res = await rqx.post(`<<global>>/${env()}/personalization/create`, body)
			if (res.msg === 'success') {
				walkthrough.set(prev => ({...prev, general: false}))
			}
		}
		
		if (['close', 'stop'].includes(action)) {
			setStepIndex(0);
			walkthrough.set(prev => ({...prev, general: false}))
			await rqx.post(`<<global>>/${env()}/personalization/create`, body)
		}

	};
	return (
			<Joyride
				continuous
				disableOverlayClose={true}
				run={walkthrough.data.general}
				steps={steps}
				stepIndex={stepIndex}
				showSkipButton={true}
				callback={handleJoyrideCallback}
				tooltipComponent={CustomComponent}
			/>
	);
};
